import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-3 sm:p-4 bg-gray-700 border-b border-gray-600 flex items-center space-x-2" }
const _hoisted_2 = { class: "flex-1 min-w-0" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between" }
const _hoisted_4 = { class: "flex-1 min-w-0 mb-2 sm:mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "text-lg sm:text-xl font-semibold text-white truncate"
}
const _hoisted_6 = ["href", "title"]
const _hoisted_7 = {
  key: 0,
  class: "flex items-center space-x-1 sm:space-x-2 flex-shrink-0"
}
const _hoisted_8 = { class: "flex sm:hidden space-x-1" }
const _hoisted_9 = { class: "hidden sm:flex space-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showBackButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
          class: "p-2 rounded-full bg-gray-600 text-white hover:bg-gray-500 md:hidden flex-shrink-0"
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.otherUser)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.otherUser.username), 1))
            : _createCommentVNode("", true),
          (_ctx.product)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: `/product/${_ctx.product.slug}`,
                class: "text-sm sm:text-base font-medium text-blue-400 hover:text-blue-300 transition-colors block truncate",
                title: _ctx.product.name
              }, _toDisplayString(_ctx.product.name), 9, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        (_ctx.otherUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('openRatingModal'))),
                  class: "p-2 bg-green-600 hover:bg-green-700 text-white rounded-md transition-colors",
                  title: "Oceni korisnika"
                }, _cache[6] || (_cache[6] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M12 2L15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2z" })
                  ], -1)
                ])),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('openBlockModal'))),
                  class: "p-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors",
                  title: "Blokiraj korisnika"
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "10"
                    }),
                    _createElementVNode("line", {
                      x1: "4.93",
                      y1: "4.93",
                      x2: "19.07",
                      y2: "19.07"
                    })
                  ], -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('openRatingModal'))),
                  class: "px-3 py-1 bg-green-600 hover:bg-green-700 text-white text-sm rounded-md transition-colors flex items-center",
                  title: "Oceni korisnika"
                }, _cache[8] || (_cache[8] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "mr-1"
                  }, [
                    _createElementVNode("path", { d: "M12 2L15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2z" })
                  ], -1),
                  _createTextVNode(" Oceni ")
                ])),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('openBlockModal'))),
                  class: "px-3 py-1 bg-red-600 hover:bg-red-700 text-white text-sm rounded-md transition-colors flex items-center",
                  title: "Blokiraj korisnika"
                }, _cache[9] || (_cache[9] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "mr-1"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "10"
                    }),
                    _createElementVNode("line", {
                      x1: "4.93",
                      y1: "4.93",
                      x2: "19.07",
                      y2: "19.07"
                    })
                  ], -1),
                  _createTextVNode(" Blokiraj ")
                ]))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}